var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main_container" }, [
    _c(
      "div",
      {
        staticClass: "container-fluid edit-story-wrapper",
        class: _vm.selectedNodeType
      },
      [
        _c("div", { staticClass: "borderEditView" }, [
          this.selectedLogic.category == "Scene" ||
          this.selectedLogic.category == "Page"
            ? _c("div", { staticClass: "tools-bar" }, [
                _c(
                  "button",
                  {
                    staticClass: "AddScene",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.activePopup(0)
                      }
                    }
                  },
                  [
                    _c("i", { staticClass: "fas fa-plus-circle" }),
                    _vm._v("\n        Add assets\n      ")
                  ]
                ),
                _vm._v(" "),
                _c("ul", { staticClass: "controls-topbar" }, [
                  _c(
                    "li",
                    {
                      attrs: { title: "play" },
                      on: {
                        click: function($event) {
                          _vm.playing ? _vm.editWEBGL() : _vm.playWEBGL()
                        }
                      }
                    },
                    [
                      _c("span", { staticClass: "nav-link" }, [
                        !_vm.playing
                          ? _c("i", { staticClass: "fab fa-unity" })
                          : _c("i", { staticClass: "fa fa-stop" })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      attrs: { id: "unity-reload-button", title: "reload" },
                      on: {
                        click: function($event) {
                          return _vm.editWEBGL()
                        }
                      }
                    },
                    [_vm._m(0)]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { attrs: { title: "undo" }, on: { click: _vm.undo } },
                    [
                      _c("span", { staticClass: "nav-link" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "16",
                              height: "14",
                              viewBox: "0 0 16 14",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M15.8543 11.885C15.9192 10.8679 15.7753 9.84816 15.4313 8.8887C15.0873 7.92925 14.5507 7.05033 13.8543 6.30604C12.3132 4.81847 10.2512 3.99295 8.10933 4.00604C8.07325 4.004 8.0393 3.98828 8.0144 3.96208C7.9895 3.93589 7.97553 3.90118 7.97533 3.86504V0.955038C7.97534 0.929612 7.96852 0.90465 7.95559 0.882759C7.94266 0.860868 7.92408 0.842851 7.90181 0.83059C7.87954 0.818329 7.85438 0.812273 7.82896 0.813056C7.80355 0.813838 7.77881 0.82143 7.75733 0.835038L0.167334 5.83504C0.147733 5.84786 0.131634 5.86536 0.120492 5.88596C0.10935 5.90656 0.103516 5.92962 0.103516 5.95304C0.103516 5.97646 0.10935 5.99951 0.120492 6.02011C0.131634 6.04072 0.147733 6.05822 0.167334 6.07104L7.75733 11.071C7.77867 11.0854 7.80354 11.0935 7.82921 11.0947C7.85489 11.0958 7.88038 11.0899 7.9029 11.0775C7.92541 11.0651 7.94408 11.0467 7.95686 11.0244C7.96963 11.0021 7.97603 10.9767 7.97533 10.951V8.08204C7.97531 8.06292 7.97918 8.04399 7.9867 8.02641C7.99421 8.00883 8.00523 7.99297 8.01908 7.97978C8.03292 7.96659 8.0493 7.95635 8.06722 7.94969C8.08515 7.94303 8.10424 7.94009 8.12333 7.94104C9.30663 7.96552 10.4709 8.24379 11.5373 8.75704C12.8805 9.4302 14.0254 10.4413 14.8593 11.691C15.1587 12.1299 15.4108 12.5991 15.6113 13.091C15.6226 13.1202 15.6423 13.1453 15.668 13.1632C15.6936 13.181 15.7241 13.1907 15.7553 13.191H15.8543C15.8543 12.775 15.8543 12.248 15.8543 11.885Z",
                                fill: "#fff"
                              }
                            })
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { attrs: { title: "redo" }, on: { click: _vm.redo } },
                    [
                      _c("span", { staticClass: "nav-link" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "16",
                              height: "14",
                              viewBox: "0 0 16 14",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M0.110854 11.885C0.0459718 10.8679 0.189937 9.84816 0.533891 8.8887C0.877844 7.92925 1.41451 7.05033 2.11085 6.30604C3.65099 4.81785 5.71223 3.99128 7.85385 4.00304C7.88994 4.001 7.92389 3.98528 7.94879 3.95909C7.97369 3.93289 7.98766 3.89818 7.98785 3.86204V0.955038C7.98784 0.929612 7.99466 0.90465 8.0076 0.882759C8.02053 0.860868 8.0391 0.842851 8.06138 0.83059C8.08365 0.818329 8.10881 0.812273 8.13422 0.813056C8.15964 0.813838 8.18438 0.82143 8.20585 0.835038L15.7959 5.83504C15.8155 5.84786 15.8316 5.86536 15.8427 5.88596C15.8538 5.90656 15.8597 5.92962 15.8597 5.95304C15.8597 5.97646 15.8538 5.99951 15.8427 6.02011C15.8316 6.04072 15.8155 6.05822 15.7959 6.07104L8.20585 11.071C8.18452 11.0854 8.15965 11.0935 8.13397 11.0947C8.1083 11.0958 8.08281 11.0899 8.06029 11.0775C8.03778 11.0651 8.01911 11.0467 8.00633 11.0244C7.99355 11.0021 7.98716 10.9767 7.98785 10.951V8.08204C7.98788 8.06292 7.98401 8.04399 7.97649 8.02641C7.96897 8.00883 7.95796 7.99297 7.94411 7.97978C7.93027 7.96659 7.91389 7.95635 7.89596 7.94969C7.87804 7.94303 7.85895 7.94009 7.83985 7.94104C6.65656 7.96552 5.49232 8.24379 4.42585 8.75704C3.08195 9.42992 1.93638 10.4411 1.10185 11.691C0.803881 12.13 0.553155 12.5993 0.353854 13.091C0.342634 13.1202 0.322907 13.1453 0.29723 13.1632C0.271554 13.181 0.241113 13.1907 0.209854 13.191H0.109854C0.107854 12.775 0.110854 12.248 0.110854 11.885Z",
                                fill: "#fff"
                              }
                            })
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      attrs: { title: "delete" },
                      on: { click: _vm.deleteNode }
                    },
                    [
                      _c("span", { staticClass: "nav-link" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "16",
                              height: "18",
                              viewBox: "0 0 16 18",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M2.07961 15.911C2.08172 16.4327 2.28998 16.9325 2.659 17.3013C3.02802 17.6701 3.52787 17.8782 4.04961 17.88H11.9496C12.4719 17.8789 12.9725 17.6713 13.3422 17.3024C13.7118 16.9334 13.9205 16.4332 13.9226 15.911V4.55999H2.07961V15.911ZM15.3996 1.6H11.6996L10.4606 0.119995H5.53861L4.29961 1.6H0.599609V3.08H15.3996V1.6Z",
                                fill: "#fff"
                              }
                            })
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      attrs: { title: "upload" },
                      on: { click: _vm.uploadJSON }
                    },
                    [_vm._m(1)]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    { attrs: { title: "save" }, on: { click: _vm.save } },
                    [_vm._m(2)]
                  )
                ]),
                _vm._v(" "),
                _c("ul", { staticClass: "tools controls-topbar " }, [
                  _c("li", { staticClass: "col-4 dropdown" }, [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.layout_type,
                            expression: "layout_type"
                          }
                        ],
                        staticClass: "custom-select",
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.layout_type = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c("option", { attrs: { value: "default" } }, [
                          _vm._v("Default")
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      attrs: { title: "Toggle Logic" },
                      on: {
                        click: function($event) {
                          return _vm.togglePanel("logic")
                        }
                      }
                    },
                    [_c("i", { staticClass: "fas fa-stopwatch fa-lg" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      attrs: { title: "Toggle Preview" },
                      on: {
                        click: function($event) {
                          return _vm.togglePanel("preview")
                        }
                      }
                    },
                    [_c("i", { staticClass: "fas fa-video fa-lg" })]
                  ),
                  _vm._v(" "),
                  _c(
                    "li",
                    {
                      attrs: { title: "Toggle Inspector" },
                      on: {
                        click: function($event) {
                          return _vm.togglePanel("inspector")
                        }
                      }
                    },
                    [_c("i", { staticClass: "fas fa-cogs fa-lg" })]
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "panel-wrapper" }, [
            _c("div", { staticClass: "panel-wrapper" }, [
              _vm.isPanelOpen.logic
                ? _c(
                    "div",
                    { staticClass: "col", attrs: { id: "logic-wrapper" } },
                    [
                      _c(
                        "div",
                        { staticClass: "card", attrs: { id: "logic" } },
                        [
                          _c("div", { staticClass: "card-action-buttons" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-primary btn-sm",
                                on: {
                                  click: function($event) {
                                    return _vm.expandPanel("logic")
                                  }
                                }
                              },
                              [
                                _c("i", {
                                  staticClass: "fas fa-expand-arrows-alt"
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-outline-warning btn-sm",
                                on: {
                                  click: function($event) {
                                    return _vm.closePanel("logic")
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fa fa-times" })]
                            )
                          ]),
                          _vm._v(" "),
                          _vm.componentType == "Logic"
                            ? _c("logicComponent")
                            : _c("timelineComponent", {
                                on: { openComponent: _vm.openComponent }
                              })
                        ],
                        1
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isPanelOpen.preview
                ? _c("div", { staticClass: "col", attrs: { id: "preview" } }, [
                    _c("div", { staticClass: "card premDiv" }, [
                      _c("div", { staticClass: "card-action-buttons" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-primary btn-sm",
                            on: {
                              click: function($event) {
                                return _vm.expandPanel("preview")
                              }
                            }
                          },
                          [_c("i", { staticClass: "fas fa-expand-arrows-alt" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-warning btn-sm",
                            on: {
                              click: function($event) {
                                return _vm.closePanel("preview")
                              }
                            }
                          },
                          [_c("i", { staticClass: "fa fa-times" })]
                        )
                      ]),
                      _vm._v(" "),
                      _vm._m(3),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          ref: "preview",
                          staticClass: "card-body p-0 position-relative"
                        },
                        [
                          _c("previewComponent", {
                            attrs: {
                              height: _vm.height,
                              width: _vm.width,
                              showShadow: _vm.showShadow,
                              showSkeleton: _vm.showSkeleton,
                              selectedAnimation: _vm.selectedAnimation,
                              selectedFbxModel: _vm.selectedFbxModel
                            }
                          })
                        ],
                        1
                      )
                    ])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.isPanelOpen.inspector
              ? _c(
                  "div",
                  {
                    staticClass: "col inspector-wrap",
                    attrs: { id: "inspector" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "card" },
                      [
                        _c("div", { staticClass: "card-action-buttons" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-primary btn-sm",
                              on: {
                                click: function($event) {
                                  return _vm.expandPanel("inspector")
                                }
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-expand-arrows-alt"
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-warning btn-sm",
                              on: {
                                click: function($event) {
                                  return _vm.closePanel("inspector")
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-times" })]
                          )
                        ]),
                        _vm._v(" "),
                        _c("inspectorComponent", {
                          attrs: {
                            showShadow: _vm.showShadow,
                            showSkeleton: _vm.showSkeleton,
                            showComponentType: _vm.openComponentType
                          },
                          on: {
                            showShadowChange: _vm.showShadowChange,
                            showSkeletonChange: _vm.showSkeletonChange,
                            showSelectedAnimation: _vm.showSelectedAnimation,
                            showSelectedModel: _vm.showSelectedModel
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              : _vm._e()
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "nav-link" }, [
      _c("i", { staticClass: "fas fa-sync" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "nav-link" }, [
      _c("i", { staticClass: "fas fa-cloud-upload-alt fa-xl" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "nav-link" }, [
      _c("i", { staticClass: "fas fa-save fa-xl" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-header" }, [
      _c(
        "div",
        { staticClass: "d-flex justify-content-between align-items-center" },
        [
          _c("span", [
            _c("i", { staticClass: "fas fa-video" }),
            _vm._v("\n                      Preview")
          ])
        ]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ffa401f2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ffa401f2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/StoryEditView1.vue
// module id = null
// module chunks = 